import axios from 'axios'
import { getBaseUrl } from './BaseService'

axios.defaults.withCredentials = true

/**
 * @typedef {Object} CustomerInfoPayload
 * @property {string} email - User's email address
 * @property {string} phoneNumber - User's phone number
 */

/**
 * Update session with contact information
 * @param {string} sessionKey - The session key
 * @param {CustomerInfoPayload} payload - Contact information
 * @returns {Promise<any>} The response data
 */
export async function updateSession(sessionKey, payload) {
  console.log(sessionKey)
  console.log('Payloasd', payload)
  try {
    const response = await axios.put(
      `${getBaseUrl()}/charge-session/widget/${sessionKey}`,
      {
        customerInfo: payload,
      }
    )
    return response.data
  } catch (error) {
    throw error.response ? error.response.data : error
  }
}

/**
 * Get session details
 * @param {string} sessionKey - The session key
 * @returns {Promise<any>} The response data
 */
export async function getSession(sessionKey) {
  try {
    const response = await axios.get(
      `${getBaseUrl()}/charge-process/widget/${sessionKey}`,
      { data: null }
    )
    return response.data
  } catch (error) {
    throw error.response ? error.response.data : error
  }
}

/**
 * Complete session
 * @param {string} sessionKey - The session key
 * @returns {Promise<any>} The response data
 */
export async function completeSession(sessionKey) {
  try {
    const response = await axios.post(
      `${getBaseUrl()}/charge-session/widget/complete/${sessionKey}`,
      {}
    )
    return response.data
  } catch (error) {
    throw error.response ? error.response.data : error
  }
}

/**
 * @typedef {Object} OtpVerificationPayload
 * @property {string} sessionKey - The session key
 * @property {string} verificationType - Type of verification
 * @property {string} email - User's email address
 * @property {string|null} [phoneNumber] - User's phone number (optional)
 * @property {'email'|'sms'} [channel] - Communication channel
 * @property {string} reference - Transaction reference
 */

/**
 * Start OTP verification for a session
 * @param {OtpVerificationPayload} payload - Request body data
 * @returns {Promise<any>} The response data
 */
export async function startSessionOtpVerification(payload) {
  try {
    const response = await axios.post(
      `${getBaseUrl()}/charge-session/widget/otp/start`,
      {
        sessionKey: payload.sessionKey,
        verification_type: payload.verificationType,
        email: payload.email,
        phoneNumber: payload.phoneNumber || null,
        channel: payload.channel,
        reference: payload.reference,
      }
    )
    return response.data
  } catch (error) {
    throw error.response ? error.response.data : error
  }
}

/**
 * @typedef {Object} CompleteOtpPayload
 * @property {string} sessionKey - The session key
 * @property {string} otpSessionId - OTP session identifier
 * @property {string} otpCode - OTP verification code
 */

/**
 * Complete OTP verification for session
 * @param {CompleteOtpPayload} payload - Request body data
 * @returns {Promise<any>} The response data
 */
export async function completeSessionOtpVerification(payload) {
  try {
    const response = await axios.post(
      `${getBaseUrl()}/charge-session/widget/otp/complete`,
      {
        sessionKey: payload.sessionKey,
        otpCode: payload.otpCode,
      }
    )
    return response.data
  } catch (error) {
    throw error.response ? error.response.data : error
  }
}

/**
 * Initiate mandate for direct debit
 * @param {string} sessionKey - The session key
 * @param {Object} payload - Mandate details (bankPublicId, address, accountNumber)
 * @returns {Promise<any>} The response data
 */
export async function initiateMandate(sessionKey, fundingSource, payload) {
  try {
    const response = await axios.post(
      `${getBaseUrl()}/charge-session/widget/${sessionKey}/${fundingSource}/initiate-mandate`,
      payload
    )
    return response.data
  } catch (error) {
    throw error.response ? error.response.data : error
  }
}

/**
 * @typedef {Object} ValidateAccountPayload
 * @property {string} bankPublicId - Bank identifier
 * @property {string} accountNumber - Account number to validate
 */

/**
 * Validate account number
 * @param {ValidateAccountPayload} payload - Request body data
 * @returns {Promise<any>} The response data
 */
export async function validateAccountNumber(sessionId, payload, currentFundingSource) {
  try {
    const response = await axios.post(
      `${getBaseUrl()}/charge-session/widget/${sessionId}/${currentFundingSource}/validate-account`,
      payload
    )
    return response.data
  } catch (error) {
    throw error.response ? error.response.data : error
  }
}
